import lang from '@/lang'
import React from 'react'
import { Route } from 'react-router'
const EconomicAssetList = React.lazy(() => import('@/modules/economicAsset/components/list/economicAsset-list'))

const economicAssetRoutes = (
  <>
    <Route path='economicAssets' Component={EconomicAssetList} handle={{ title: lang.economicAssetTitle, options: { noBackgroundColor: true } }} />
  </>
)

export default economicAssetRoutes
